import * as React from 'react';
import { NavbarStyleType } from './navigation-bar.types';
import { ReactNode } from 'react';
import { animated } from '@react-spring/web';
import { useMobileNavbarCrossingAnimation } from './hooks/use-navbar-crossing-animation';

import { cn } from '@restworld/utils-common';
export const Navbar = ({
  children,
  testId,
  additionalContentEl,
  ...restProps
}: NavbarStyleType & { children: ReactNode; testId?: string; additionalContentEl?: ReactNode }) => {
  const { hasCrossedNavbar } = useMobileNavbarCrossingAnimation();
  return (
    <StyledNavbar data-cy={testId} {...{ ...restProps, hasCrossed: hasCrossedNavbar }} id="navbarContainer">
      {children}
      {additionalContentEl}
    </StyledNavbar>
  );
};

export const containerHeightMapping = {
  default: 'md:h-[88px] h-[74px] md:max-h-[88px] max-h-[74px] py-4',
  'nav-open':
    'lg:h-[88px] md:h-[120px] h-[116px] lg:max-h-[88px] md:max-h-[120px] max-h-[116px] md:pt-6 md:pb-4 pt-6 pb-4',
};

export const alignMapping = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
};

export type ContainerProps = {
  children?: ReactNode;
  justify?: 'between' | 'start';
  height?: keyof typeof containerHeightMapping;
  align?: keyof typeof alignMapping;
};

export const Container = ({ children, height = 'default', align = 'center', ...restProps }: ContainerProps) => {
  const { hasCrossedNavbar, navbarAnimation } = useMobileNavbarCrossingAnimation();
  return (
    <StyledContainer
      height={height}
      align={align}
      {...restProps}
      style={hasCrossedNavbar ? navbarAnimation : undefined}
    >
      {children}
    </StyledContainer>
  );
};

const StyledNavbar = ({
  background,
  hasCrossed,
  position,
  hasBorderedBottom,
  hasRoundedBottom,
  twStyle,
  className,
  ...props
}: any) => (
  <nav
    className={cn(
      'w-full z-50',
      {
        white: 'bg-neutral-10',
        'purple-gradient': 'bg-gradient-base',
        'home-mobile-nav': hasCrossed ? 'bg-homeMobileNav' : 'bg-transparent',
      }[background],
      { fixed: 'fixed', relative: 'relative' }[position || 'fixed'],
      hasBorderedBottom ? 'border-b border-gray-200' : 'border-b-0',
      hasRoundedBottom ? 'rounded-b-3xl' : '',
      twStyle,
      className
    )}
    {...props}
  />
);

const StyledContainer = ({ justify = 'start', height, align, className, ...props }: any) => (
  <animated.div
    className={cn(
      'box-border flex gap-4 lg:justify-start md:justify-between justify-between items-center',
      { between: 'md:justify-between', start: 'md:justify-start' }[justify as string],
      alignMapping[align as keyof typeof alignMapping],
      'px-0',
      containerHeightMapping[height as keyof typeof containerHeightMapping],
      className
    )}
    {...props}
  />
);

export const HorizontalMenuWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex items-center md:ml-4 lg:ml-0', className)} {...props} />
);
